import { Text } from "react-native-paper";
import { View } from "react-native";
import { Feather } from "@expo/vector-icons";
import { colors } from "../../../theme";

const creditCategoryMap: { [key: string]: string } = {
  EDUCATION: "Education",
  PLAYER_ENGAGEMENT: "Player Engagement",
  MEETINGS: "Meetings",
  NATIONAL_SURVEYS: "National Surveys",
};

export const getCreditCategory = (creditCategory: string) => {
  return creditCategoryMap[creditCategory];
};

export const renderVideoStatusChip = (memberVideoStatus: string | null) => {
  let iconName: keyof typeof Feather.glyphMap;
  let textColor: string;
  let bgColor: string;
  let iconColor: string;

  switch (memberVideoStatus) {
    case "Completed":
      iconName = "check";
      textColor = "text-green-dark";
      bgColor = "bg-green-100";
      iconColor = colors.green.dark;
      break;
    case "In Progress":
      iconName = "play";
      textColor = "text-blue-dark";
      bgColor = "bg-blue-lightest";
      iconColor = colors.blue.dark;
      break;
    case "Unavailable":
      iconName = "info";
      textColor = "text-ink-dark";
      bgColor = "bg-gray-100";
      iconColor = colors.ink.dark;
      break;
    case "Go to Course":
      iconName = "external-link";
      textColor = "text-primary-light";
      bgColor = "bg-white border border-primary-light";
      iconColor = colors.primary.light;
      break;
    default:
      if (memberVideoStatus?.startsWith("Expiring")) {
        iconName = "info";
        textColor = "text-orange-800";
        bgColor = "bg-orange-100";
        iconColor = "#9A3412";
      } else {
        iconName = "help-circle";
        textColor = "text-ink-dark";
        bgColor = "bg-gray-100";
        iconColor = colors.ink.dark;
      }
  }

  return memberVideoStatus ? (
    <View className={`flex-row items-center ${bgColor} rounded-full px-2 py-1 mb-2 self-start`}>
      <Feather name={iconName} size={16} color={iconColor} />
      <Text className={`${textColor} text-tiny font-500 ml-1`}>{memberVideoStatus}</Text>
    </View>
  ) : null;
};
